
import Box, { BoxColor, BoxColorVariant } from '@/elements/box/Box';
import { defineComponent } from 'vue';
import Icon from '@/elements/icon/Icon.vue';

export default defineComponent({
  components: {
    Icon,
    Box,
  },
  props: {
    color: {
      type: String as () => BoxColor,
      default: 'transparent',
    },
    variant: {
      type: String as () => BoxColorVariant,
      default: 'neutral',
    },
    summary: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
  },
});
